
  import Vue from "vue";
  import PwaPrice from "@/components/common/PwaPrice.vue";

  export default Vue.extend({
    name: "pwa-competition-individual-row",
    components: {
      PwaPrice,
    },
    props: {
      competition: {
        type: Object,
        required: true,
      }
    },
  });
